import ApiService from "@/api.service";
import JwtService from "@/jwt.service";
import API from "@/API";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const CHANGE_PASSWORD_USER = "changePasswordUser";
export const USER_CURRENT = "userCurrent";
// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_USER_CURRENT = "setUserCurent";
export const SET_ERROR = "setError";

const state = {
    errors: null,
    user: {},
    isAuthenticated: !!JwtService.getToken()
};

const getters = {
    currentUser(state) {
        return state.user;
    },
    isAuthenticated(state) {
        return state.isAuthenticated;
    }
};

const actions = {
    [LOGIN](context, credentials) {
        return new Promise(resolve => {
            ApiService.post("admin/auth/login", credentials)
                .then(({ data }) => {
                    context.commit(SET_AUTH, data);
                    resolve(data);
                })
            // .catch(({ response }) => {
            //   context.commit(SET_ERROR, response.data.errors);
            // });
        });
    },
    [USER_CURRENT](context, payload) {
        return new Promise(resolve => {
            ApiService.query("admin/auth/me", payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_USER_CURRENT, data);
                }
                resolve(data);
            });
        });
    },
    [LOGOUT](context) {
        context.commit(PURGE_AUTH);
    },
    [REGISTER](context, credentials) {
        return new Promise((resolve) => {
            ApiService.post("users", { user: credentials })
                .then(({ data }) => {
                    context.commit(SET_AUTH, data);
                    resolve(data);
                })
            // .catch(({ response }) => {response.data.errors);
            //   reject(response);
            // });
        });
    },
    [VERIFY_AUTH](context) {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.query("verify")
                .then(({ data }) => {
                    context.commit(SET_AUTH, data);
                })
            // .catch(({ response }) => {
            //   context.commit(SET_ERROR, response.data.errors);
            // });
        } else {
            context.commit(PURGE_AUTH);
        }
    },
    [UPDATE_USER](context, payload) {
        const { email, username, password, image, bio } = payload;
        const user = { email, username, bio, image };
        if (password) {
            user.password = password;
        }

        return ApiService.put("user", user).then(({ data }) => {
            context.commit(SET_AUTH, data);
            return data;
        });
    },
    [CHANGE_PASSWORD_USER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${API.CHANGE_PASSWORD_USER}`, payload)
                .then((data) => {
                    console.log(1, data)
                    resolve(data)
                })
                .catch((err) => {
                    console.log(1, err)
                    reject(err);
                });
        });
    }
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_AUTH](state, user) {
        state.isAuthenticated = true;
        state.user = user;
        state.errors = {};
        if (state.user) {
            JwtService.saveToken(state.user.access_token);
            JwtService.saveUser(state.user.data);
            ApiService.setHeader();
        }
    },
    [PURGE_AUTH](state) {
        state.isAuthenticated = false;
        state.user = {};
        state.errors = {};
        JwtService.destroyToken();
        JwtService.destroyUser();
    },
    [SET_USER_CURRENT](state, user) {
        state.user = user;
        if (state.user) {
            JwtService.saveUser(state.user.data);
        }
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
